module.exports = __webpack_public_path__ + "img/field-project-10.563acc2b.svg";